import React, { useEffect, useState } from 'react';
import { FadeIn } from '../ui/FadeIn';
import { AlertTriangleIcon, ClockIcon } from 'lucide-react';
function useCountdown(hoursAhead: number) {
  const [target] = useState(() => Date.now() + hoursAhead * 60 * 60 * 1000);
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  const diff = Math.max(0, target - now);
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor(diff / (1000 * 60) % 60);
  const seconds = Math.floor(diff / 1000 % 60);
  return {
    hours,
    minutes,
    seconds
  };
}
export function UrgencySection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(23);
  const Cell = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="card-glass rounded-md px-5 py-4 min-w-[80px] text-center" data-id="element-299">
      <div className="text-3xl md:text-4xl font-serif text-gold-400 tabular-nums" data-id="element-300">
        {String(value).padStart(2, '0')}
      </div>
      <div className="text-xs uppercase tracking-widest text-cream-muted mt-1" data-id="element-301">
        {label}
      </div>
    </div>;
  return <section className="py-16 md:py-20 bg-[#0a0e1a]" data-id="element-302">
      <div className="max-w-3xl mx-auto px-6" data-id="element-303">
        <FadeIn data-id="element-304">
          <div className="card-glass rounded-md p-8 md:p-12 text-center" style={{
          borderColor: 'rgba(201,168,76,0.5)'
        }} data-id="element-305">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold-500/20 mb-6" data-id="element-306">
              <AlertTriangleIcon className="w-4 h-4 text-gold-400" data-id="element-307" />
              <span className="text-sm uppercase tracking-widest text-gold-400 font-medium" data-id="element-308">
                Precio de Lanzamiento
              </span>
            </div>

            <h2 className="text-2xl md:text-3xl font-serif mb-4" data-id="element-309">
              Este precio de <span className="text-gold-400" data-id="element-310">$27 USD</span> es
              exclusivo por tiempo limitado
            </h2>
            <p className="text-cream-muted text-body-lg mb-8" data-id="element-311">
              Después del lanzamiento, el precio regular será{' '}
              <span className="text-white font-medium line-through decoration-gold-500/60" data-id="element-312">
                $47 USD
              </span>
              .
            </p>

            <div className="flex items-center justify-center gap-2 mb-5 text-cream-muted text-sm uppercase tracking-widest" data-id="element-313">
              <ClockIcon className="w-4 h-4 text-gold-400" data-id="element-314" />
              <span data-id="element-315">Termina en</span>
            </div>

            <div className="flex justify-center gap-3 md:gap-4" data-id="element-316">
              <Cell value={hours} label="Horas" data-id="element-317" />
              <Cell value={minutes} label="Min" data-id="element-318" />
              <Cell value={seconds} label="Seg" data-id="element-319" />
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}